import TalentResume from "./TalentResume";

export default TalentResume;